<div class="container mx-auto px-4 py-8 max-w-2xl">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 text-center uppercase">CREAR NUEVA TARIFA</h2>
  <div class="bg-white shadow-md rounded-lg px-8 py-6">
    <form class="space-y-4" [formGroup]="feesForm" (ngSubmit)="handleCreateFee()">
      <div *ngIf="isLoading" class="flex justify-center items-center mt-5">
        <mat-spinner class="text-orange-500 animate-spin" strokeWidth="3" [diameter]="70"></mat-spinner>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>CIF</mat-label>
            <input type="text" matInput id="cif" formControlName="cif" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Delegación</mat-label>
            <input type="text" matInput id="delegation" formControlName="delegation"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Código de Cliente</mat-label>
            <input type="text" matInput id="clientCode" formControlName="clientCode"
              class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>ID de Concepto</mat-label>
            <input type="text" matInput id="conceptId" formControlName="conceptId" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>ID de Familia</mat-label>
            <input type="text" matInput id="familyId" formControlName="familyId" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Familia</mat-label>
            <input type="text" matInput id="family" formControlName="family" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Monto</mat-label>
            <input type="text" matInput id="amount" formControlName="amount" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Descuento</mat-label>
            <input type="text" matInput id="discount" formControlName="discount" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Método de Pago</mat-label>
            <input type="text" matInput id="payMethod" formControlName="payMethod" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Día de Pago</mat-label>
            <input type="text" matInput id="payDay" formControlName="payDay" class="form-input mt-1 block w-full">
          </mat-form-field>
        </div>
      </div>

      <div class="w-full">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Descripción</mat-label>
          <textarea matInput formControlName="description" id="description" class="form-input mt-1 block w-full"
            mat-autosize></textarea>
        </mat-form-field>
      </div>

      <button type="submit" class="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded">
        CREAR TARIFA
      </button>
    </form>
  </div>
</div>